/**
 * @fileoverview Authentication route definitions.
 */

import type { RouteObject } from 'react-router';
import { SignInPage } from '../../features/auth';
import { createRoutes } from '../utils/routeHelpers';

export const authRoutes: RouteObject[] = createRoutes([
  { path: '/sign-in', Component: SignInPage },
]);
